import Vue from "vue";
import VueRouter from "vue-router";
import SensorMap from "../views/SensorMap.vue";
import Login from "../views/Login.vue";
import Logout from "../views/Logout.vue";
import Dashboard from "../views/Dashboard.vue";
import Summaries from "../views/Summaries.vue";
import Playback from "../views/Playback.vue";

Vue.use(VueRouter);

const routes = [
    {
        name: "Login",
        path: "/login",
        meta: { isPublic: true },
        component: Login,
    },
    {
        name: "Logout",
        path: "/logout",
        meta: { isPublic: true },
        component: Logout,
    },
    {
        name: "index",
        path: "/",
        redirect: "/sensor-map",
    },
    {
        name: "SensorMap",
        path: "/sensor-map",
        component: SensorMap,
    },
    {
        name: "Dashboard",
        path: "/dashboard",
        component: Dashboard,
    },
    {
        name: "Summaries",
        path: "/summaries",
        component: Summaries,
    },
    {
        name: "Playback",
        path: "/playback/:device_id/:target_date",
        component: Playback,
    },
];

const router = new VueRouter({
    routes,
});

export default router;
